import React, { useEffect } from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import { withRouter } from "react-router"
import { Icon, Popconfirm, Table, Tag } from "antd"
import moment from "moment"

const parsePayload = (payload) => {
  try {
    return payload ? JSON.parse(payload) : {}
  } catch {
    return {}
  }
}

const PendingPayments = (props) => {
  const { getPendingPayments, pendingPayments } = props

  useEffect(() => {
    getPendingPayments(1, 15)
  }, [])

  const handleTableChange = (pagination) => {
    getPendingPayments(pagination.current, pagination.pageSize)
  }

  const handleCancel = (record) => {
    props.refund(record.generated_token)
  }

  const columns =
    props.screenWidth > 850
      ? [
          {
            title: "Data",
            dataIndex: "created_at",
            key: "created_at",
            width: "14%",
            ellipsis: true,
            render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
          },
          {
            title: "Servizio ID",
            key: "service_id",
            width: "14%",
            ellipsis: true,
            render: (_, record) => {
              const payload = parsePayload(record.payload_data)
              return payload.service_id || "-"
            },
          },
          {
            title: "PSP Reference",
            key: "pspReference",
            width: "16%",
            ellipsis: true,
            render: (_, record) => {
              return record.pspReference || "-"
            },
          },
          {
            title: "Importo",
            key: "amount",
            width: "10%",
            ellipsis: true,
            render: (_, record) => {
              const payload = parsePayload(record.payload_data)
              const amount = payload.amount
              return amount ? `${Number(amount).toFixed(2)} €` : "-"
            },
          },
          {
            title: "Telefono",
            key: "phone_number",
            width: "14%",
            ellipsis: true,
            render: (_, record) => {
              const payload = parsePayload(record.payload_data)
              return payload.phone_number || "-"
            },
          },
          {
            title: "Stato",
            dataIndex: "status",
            key: "status",
            width: "8%",
            ellipsis: true,
            align: "center",
            render: (status) =>
              status === 0 ? (
                <Tag color="orange">In sospeso</Tag>
              ) : (
                <Tag color="green">Completato</Tag>
              ),
          },
          {
            title: "Azioni",
            key: "actions",
            width: "8%",
            ellipsis: true,
            align: "center",
            render: (_, record) =>
              record.cancelled === 0 ? (
                <Popconfirm
                  title="Sei sicuro di voler annullare il pagamento?"
                  onConfirm={() => handleCancel(record)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tag color="red" style={{ cursor: "pointer" }}>
                    Cancella
                  </Tag>
                </Popconfirm>
              ) : (
                <Tag
                  style={{
                    color: "#ff4d4f",
                    backgroundColor: "#fff1f0",
                    borderColor: "#ffccc7",
                    opacity: 0.6,
                    cursor: "not-allowed",
                  }}
                >
                  Cancellato
                </Tag>
              ),
          },
        ]
      : [
          {
            title: "Data",
            dataIndex: "created_at",
            key: "created_at",
            width: "30%",
            ellipsis: true,
            render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
          },
          {
            title: "PSP Reference",
            key: "pspReference",
            width: "40%",
            ellipsis: true,
            render: (_, record) => {
              return record.pspReference || "-"
            },
          },
          {
            title: "Azioni",
            key: "actions",
            width: "30%",
            ellipsis: true,
            align: "center",
            render: (_, record) =>
              record.cancelled === 0 ? (
                <Popconfirm
                  title="Sei sicuro di voler annullare il pagamento?"
                  onConfirm={() => handleCancel(record)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tag color="red" style={{ cursor: "pointer" }}>
                    Cancella
                  </Tag>
                </Popconfirm>
              ) : (
                <Tag
                  style={{
                    color: "#ff4d4f",
                    backgroundColor: "#fff1f0",
                    borderColor: "#ffccc7",
                    opacity: 0.6,
                    cursor: "not-allowed",
                  }}
                >
                  Cancellato
                </Tag>
              ),
          },
        ]

  return (
    <div
      className="Container Annunci Movimenti PendingPayments"
      style={{ width: "100%" }}
    >
      <div className="container-fluid overview">
        <div className="movimenti-header-container">
          <div className="left">
            <h1>
              <Icon type="credit-card" />
              &nbsp;Pagamenti in sospeso
            </h1>
          </div>
        </div>

        <div className="panels-container">
          <Table
            rowKey="id"
            columns={columns}
            dataSource={pendingPayments?.data || []}
            loading={pendingPayments?.loading}
            pagination={{
              current: pendingPayments?.current_page || 1,
              pageSize: 15,
              total: pendingPayments?.total || 0,
              showSizeChanger: false,
            }}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  screenWidth: state.main.screenWidth,
  pendingPayments: state.main.pendingPayments,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  withRouter(PendingPayments)
)
